module.exports = __webpack_public_path__ + "static/media/YogaPets.5e49451f.png";